import { Injectable } from '@angular/core';
import { NavigationActionButton } from 'src/app/components/navigation-bar/models/navigation-action-button.model';
import { SettingsPreferences } from './models/settings-preferences.model';

@Injectable({
	providedIn: 'root'
})
export class GlobalSettingsService {

	public static isGlobalLoaderLoading = true;
	public static isSecondaryLoaderLoading = false;

	public static isGlobalHeadingVisible = true;

	public static isJobCompletedStatusVisible = false;
	public static isJobCompletedStatusVisibleForJobDetails = false;

	public static showPreferencesButton = true;
	public static openPreferencesModal: () => void = null;
	public static preferencesPayload: SettingsPreferences = {} as SettingsPreferences;
	public static preferencesPayloadForJobDetails: SettingsPreferences = {} as SettingsPreferences;

	public static navigationBarActions: Map<string, NavigationActionButton> = new Map<string, NavigationActionButton>();

	// Used for custom buttons overwriting usual actions in specific pages
	// Will be prioritized on top of navigationBarActions if not null
	public static priorityNavigationBarActions: Map<string, NavigationActionButton> = null;

}
